module.exports = window.jQuery || {};